import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { takeWhile, concatMap, Observable, filter } from 'rxjs';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { AuthService } from 'src/app/services/auth.service';
import { CareerService } from 'src/app/services/career.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { USER_ID } from 'src/app/utils/constants';
import Swal from 'sweetalert2';

export interface Fruit {
  name: string;
}

@Component({
  selector: 'app-view-all-jobs',
  templateUrl: './view-all-jobs.component.html',
  styleUrls: ['./view-all-jobs.component.scss']
})
export class ViewAllJobsComponent implements OnInit {
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;

  applicantId: any;
  salaryHide: boolean = false;
  companyDetailsHide: boolean = false;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  data: any[] = [];
  showNoRecordsFounds: boolean = true;
  filterObject: any;
  countries!: any[];
  states!: any[];
  cities!: any[];
  jobTypes!: any[];
  jobSkills!: any[];
  specialities!: any[];
  savedJobs = new Set<number>();
  isJobSave = true;
  obs!: Observable<any>;

  pageSize = 6;
  currentPage = 0;
  totalData = this.data.length;
  dataSource = new MatTableDataSource<any[]>;
  paginator!: MatPaginator;

  selectedSortOption: string = '';
  currentSortDirection: string = 'asc';
  searchSuggestions: any;
  isSugestionOpen: boolean = false;
  jobFilterForm: FormGroup = new FormGroup({
    specialities: new FormControl(null),
    keywords: new FormControl(null),
    countries: new FormControl(null),
    states: new FormControl(null),
    cities: new FormControl(null),
    salaryFrom: new FormControl(null),
    salaryTo: new FormControl(null),
    experience: new FormControl(null),
    jobTypes: new FormControl(null),
    postedDate: new FormControl(null),
    skills: new FormControl(null),
    showOnlyActiveJobPosts: new FormControl(true)
  });

  countryControl = new FormControl();
  stateControl = new FormControl();
  cityControl = new FormControl();
  specialtyControl = new FormControl();
  jobTypeControl = new FormControl();
  skillsControl = new FormControl();

  filteredCountries: any[] = [];
  filteredStates: any[] = [];
  filteredCities: any[] = [];
  filteredSpecialities: any[] = [];
  filteredJobTypes: any[] = [];
  filteredSkills: any[] = [];
  isApplicationsClosed: boolean = false;
  textFromUniversalSearch:string='';
  paramsSearch: any;
  debounceTimer: any;

  onOptionSelected(event :any, filterType: string) {
    let currentValues: any[] = [];
    switch (filterType) {
      case 'country':
        currentValues = this.jobFilterForm.get('countries')?.value || [];
        if (!currentValues.includes(event.option.value.countryName)) {
          this.jobFilterForm.get('countries')?.setValue([...currentValues, event.option.value.countryName]);
          this.jobFilterForm.get('states')?.setValue([]);
          this.jobFilterForm.get('cities')?.setValue([]);
          this.loadStates();
        }
        this.countryControl.reset();
        break;
        case 'state':
        currentValues = this.jobFilterForm.get('states')?.value || [];
        if (!currentValues.includes(event.option.value.stateName)) {
          this.jobFilterForm.get('states')?.setValue([...currentValues, event.option.value.stateName]);
          this.jobFilterForm.get('cities')?.setValue([]);
          this.loadCities();
        }
        this.stateControl.reset();
        break;
      case 'city':
          currentValues = this.jobFilterForm.get('cities')?.value || [];
          if (!currentValues.includes(event.option.value.cityName)) {
            this.jobFilterForm.get('cities')?.setValue([...currentValues, event.option.value.cityName]);
          }
          this.cityControl.reset();
          break;
      case 'speciality':
        currentValues = this.jobFilterForm.get('specialities') ?.value || [];
        if (!currentValues.includes(event.option.value.specialty)) {
          this.jobFilterForm.get('specialities')?.setValue([...currentValues, event.option.value.specialty]);
        }
        this.specialtyControl.reset();
        break;
      case 'jobType':
        currentValues = this.jobFilterForm.get('jobTypes') ?.value || [];
        if (!currentValues.includes(event.option.value.jobType)) {
          this.jobFilterForm.get('jobTypes')?.setValue([...currentValues, event.option.value.jobType]);
        }
        this.jobTypeControl.reset();
        break;
      case 'skills':
        currentValues = this.jobFilterForm.get('skills') ?.value || [];
        if (!currentValues.includes(event.option.value.name)) {
          this.jobFilterForm.get('skills')?.setValue([...currentValues, event.option.value.name]);
        }
        this.skillsControl.reset();
        break;
    }
  }

  getFormFields(): string[] {
    return Object.keys(this.jobFilterForm.controls);
  }

  removeField(field: string): void {
    this.jobFilterForm.get(field)?.setValue(null);
  }

  removeArrayItem(field: string, value: any): void {
    const currentArray = this.jobFilterForm.get(field)?.value;
    if (Array.isArray(currentArray)) {
      const updatedArray = currentArray.filter((item: any) => item !== value);
      this.jobFilterForm.get(field)?.setValue(updatedArray);
    }
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  userId!: string;
  roleName:boolean = false;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.dataSource.paginator = this.paginator;
  }

  constructor(private readonly masterDataService: MasterDataService,
    private readonly careerService: CareerService, private readonly endCustomerService: EndCustomerService,
    private readonly localStorageService: LocalStorageService,
    private snackbarService: SnackbarService, private route: ActivatedRoute, private readonly router: Router, private swalService: SweetAlertService, private spinnerService: SpinnerService
    ,private renderer: Renderer2, private authService: AuthService,private sharedService: SharedService,private activatedRoute: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if (params !== undefined && params !== null && Object.entries(params).length > 0) {
        if (this.checkAndConvertArray(params['speciality']) !== null) {
          this.jobFilterForm.get('specialities')?.setValue([params['speciality']]);
        }
        if (this.checkAndConvertArray(params['keywords']) !== null) {
          let keywordsCurrentValue = this.jobFilterForm.get('keywords')?.value;
          const keywordsNewValue = (keywordsCurrentValue !== undefined && keywordsCurrentValue !== null) ? [...keywordsCurrentValue, params['keywords']] : [params['keywords']];
          this.jobFilterForm.get('keywords')?.setValue(keywordsNewValue);
        }
      }
      const prevFilter = window.history.state?.prevFilter;
      if(prevFilter === true){
      this.jobFilterForm.patchValue(window.history.state?.previousFilterForm);
      this.getAllJobPostByFilter();
      }else {
        this.getAllJobPostByFilter();
      }
    });

      window.addEventListener('scroll', this.scrollEvent, true);
    this.route.queryParams.subscribe(params => {
      const page = params['page'] ? +params['page'] : 0;
      this.currentPage = page;
    });
  }
  @ViewChild('searchContainer') searchContainer: ElementRef | undefined;
  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
      if(autoComplete.panelOpen){
        const panel = autoComplete.autocomplete.panel;
        return panel && panel.nativeElement.contains(target);
      }
      return false;
    })
    if(!isScrollingInsidePanel){
      this.closeAllPanels();
    }
  }
  closeAllPanels() {
    this.autoCompletes.forEach(autoComplete => {
      if (autoComplete.panelOpen) {
        autoComplete.closePanel();
      }
    });
  }
  ngOnInit(): void {
    this.showNoRecordsFounds=false;
    this.topOfPage();
    this.loadCountries('');
    this.loadJobTypes();
    this.loadJobSkills();
    this.loadSpecialities();
    this.checkForFormValueChange();
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.paramsSearch = params.get('search') || '';
      this.textFromUniversalSearch = this.paramsSearch ;
      this.searchSuggestion(this.paramsSearch)
      this.paramsSearch ='';
    })
    this.countryControl.valueChanges.subscribe(value => {
      if (!value?.countryName) {
        this.filteredCountries = this.countries.filter(country =>
          country.countryName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.stateControl.valueChanges.subscribe(value => {
      if (!value?.stateName) {
        this.filteredStates = this.states.filter(state =>
          state.stateName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.cityControl.valueChanges.subscribe(value => {
      if (!value?.cityName) {
        this.filteredCities = this.cities.filter(city =>
          city.cityName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.specialtyControl.valueChanges.subscribe(value => {
      if (!value?.specialty) {
        this.filteredSpecialities = this.specialities.filter(specialty =>
          specialty.specialty.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.jobTypeControl.valueChanges.subscribe(value => {
      if (!value?.jobType) {
        this.filteredJobTypes = this.jobTypes.filter(jobType =>
          jobType.jobType.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.skillsControl.valueChanges.subscribe(value => {
      if (!value?.name) {
        this.filteredSkills = this.jobSkills.filter(skill =>
          skill.name.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }

    });
    this.localStorageService.getUserDetails().subscribe(data => {
      this.userId = data?.userId;
      this.getEndCustomerByUserId(data?.userId);
    });
    const roleName = localStorage.getItem('roleName') ?? '';
    this.roleName = roleName === 'USER';
    this.jobFilterForm.get('showOnlyActiveJobPosts')?.setValue(false);

    this.renderer.listen('document', 'click', (event: Event) => {
      const searchElement = this.searchContainer?.nativeElement;

      if (searchElement && !searchElement.contains(event.target)) {
        this.isSugestionOpen = false;
      }
    });

  }

  toggleSuggestions() {
    this.isSugestionOpen = !this.isSugestionOpen;
  }


  topOfPage(){
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    }else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  checkForFormValueChange() {
    this.jobFilterForm.valueChanges.subscribe(() => this.getAllJobPostByFilter());
  }

  private loadCountries(continentName: string) {
    let pageNumber = 0;
    let pageSize = 250;
    let allCountries: any[] = [];
    let morePages = true;

    this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false; // No more items to fetch
            return [];
          }
          allCountries = allCountries.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]);
        })
      )
      .subscribe(data => {
        allCountries = allCountries.concat(data.data);
        this.countries = allCountries;
        if(this.filteredCountries.length === 0){
          this.filteredCountries = this.countries;
        }
      });
  }
   private loadStates() {
    if(!this.jobFilterForm.get('countries')) {
       return;
    }
    let pageNumber = 0;
    let pageSize = 1000;
    let allStates: any[] = [];
    let morePages = true;
    this.masterDataService.getStates(pageNumber, pageSize, '', [this.jobFilterForm.get('countries')?.value])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allStates = allStates.concat(response.data);
          pageNumber++;
          return this.masterDataService.getStates(pageNumber, pageSize, '', [this.jobFilterForm.get('countries')?.value]);
        })
      )
      .subscribe(data => {
        allStates = allStates.concat(data.data);
        this.states = allStates;
        this.filteredStates = allStates;
      });
  }
  private loadCities() {
    if(!this.jobFilterForm.get('states')) {
      return;
    }
    let pageNumber = 0;
    let pageSize = 1000;
    let allCities: any[] = [];
    let morePages = true;
    this.masterDataService.getCities(pageNumber, pageSize, '', this.jobFilterForm.get('states')?.value)
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCities = allCities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCities(pageNumber, pageSize, '', this.jobFilterForm.get('states')?.value);
        })
      )
      .subscribe(data => {
        if (data.data) {
          allCities = allCities.concat(data.data);
        }
        this.cities = allCities;
        this.filteredCities = allCities;
      });
  }

  private loadJobTypes() {
    let pageNumber = 0;
    let pageSize = 100;
    let allJobTypes: any[] = [];
    let morePages = true;

    this.masterDataService.getJobTypes(pageNumber, pageSize, '')
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allJobTypes = allJobTypes.concat(response.data);
          pageNumber++;
          return this.masterDataService.getJobTypes(pageNumber, pageSize, '');
        })
      )
      .subscribe(data => {
        allJobTypes = allJobTypes.concat(data.data);
        this.jobTypes = allJobTypes;
        if(this.filteredJobTypes.length === 0){
          this.filteredJobTypes = this.jobTypes;
        }
      });
  }

  private loadJobSkills() {
    let pageNumber = 0;
    let pageSize = 100;
    let allJobSkills: any[] = [];
    let morePages = true;

    this.masterDataService.getJobSkills(pageNumber, pageSize, '')
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allJobSkills = allJobSkills.concat(response.data);
          pageNumber++;
          return this.masterDataService.getJobSkills(pageNumber, pageSize, '');
        })
      )
      .subscribe(data => {
        this.jobSkills = allJobSkills;
        if(this.filteredSkills.length === 0) {
          this.filteredSkills = this.jobSkills;
        }
      });
  }

  private loadSpecialities() {
    let pageNumber = 0;
    let pageSize = 100;
    let allSpecialities: any[] = [];
    let morePages = true;

    this.masterDataService.getSpecialities(pageNumber, pageSize, '')
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allSpecialities = allSpecialities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getSpecialities(pageNumber, pageSize, '');
        })
      )
      .subscribe(data => {
        allSpecialities = allSpecialities.concat(data.data);
        this.specialities = allSpecialities;
        if(this.filteredSpecialities.length === 0) {
          this.filteredSpecialities = allSpecialities;
        }
      });
  }

  private getAllJobPostByFilter() {
    this.spinnerService.showSpinner();
    this.data = [];
    const jobPostFilter = this.jobFilterForm.value;
    jobPostFilter.countries = this.checkAndConvertArray(jobPostFilter.countries);
    jobPostFilter.states = this.checkAndConvertArray(jobPostFilter.states);
    jobPostFilter.cities = this.checkAndConvertArray(jobPostFilter.cities);
    jobPostFilter.skills = this.checkAndConvertArray(jobPostFilter.skills);
    jobPostFilter.specialities = this.checkAndConvertArray(jobPostFilter.specialities);
    jobPostFilter.jobTypes = this.checkAndConvertArray(jobPostFilter.jobTypes);
    jobPostFilter.keywords = this.checkAndConvertArray(jobPostFilter.keywords);

    this.careerService.executePostRequest(MweConstants.getJobPostFilterUrl, JSON.parse(JSON.stringify(jobPostFilter))).subscribe({
      next: (data) => {
        if (data && data?.data && data.data.length > 0) {
          this.data = data.data;
          if (this.data.length > 0) {
            this.dataSource = new MatTableDataSource<any[]>(this.data);
            this.dataSource.paginator = this.paginator;
            this.obs = this.dataSource.connect();
            this.totalData = data?.totalCount;
            this.updateCardData();
            this.showNoRecordsFounds = false;
          } else {
            this.showNoRecordsFounds = true;
          }
          this.spinnerService.hideSpinner();
        } else {
          this.spinnerService.hideSpinner();
          this.showNoRecordsFounds = true;
        }
      },
      error: (error) => {
        this.spinnerService.hideSpinner();
        this.showNoRecordsFounds = true;
      }
    });
  }
  isApplicationClosed(applicationCloseDate: any): boolean {
    const closeDate = new Date(applicationCloseDate);
    const closeTime = new Date(applicationCloseDate);
    closeTime.setHours(23, 59, 59, 0);
    closeDate.setTime(closeTime.getTime());
    const currentDate = new Date();
    return closeDate <= currentDate;
  }
  getEndCustomerByUserId(userId: any) {
    if (userId) {
    this.endCustomerService.executeGetRequestURL(MweConstants.getCustomerByUserId + userId, null).subscribe({
      next: (response: any) => {
        if (response && response?.data) {
          this.applicantId = response?.data.id;
          this.findSavedJobFilter();
        }
      }, error: (error: any) => {
      }
    });
  }
  }

  findSavedJobFilter(): void{
    const jobApplicationFilter = { applicantId: this.applicantId, isSaved: this.isJobSave };
    this.careerService.executePostRequest(MweConstants.getJobPostUrl.concat("/applicant/jobs/filter"), JSON.parse(JSON.stringify(jobApplicationFilter))).subscribe({
      next: (response) => {
        const savedJobIds = new Set(response.data.map((savedData: any) => savedData.jobPostId));
        this.data.forEach((data) => {
          if (savedJobIds.has(data.id)) {
            this.savedJobs.add(data.id);
          }
        });
      }, error: (error) => {
      }
    });
  }

  changePage(pageIndex: number) {
    this.currentPage = pageIndex;
    this.updateCardData();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: this.currentPage },
      queryParamsHandling: 'merge',
    });
    this.topOfPage();
  }

  updateCardData() {
    this.totalData = this.data?.length;
    if (this.paginator) {
      this.paginator.pageIndex = this.currentPage;
      this.dataSource.paginator = this.paginator;
    }
  }

  getTotalPages(): number {
    return Math.ceil(this.totalData / this.pageSize);
  }

  getPageNumbers(): (number | string)[] {
    const totalPages = this.getTotalPages();
    const currentPage = this.currentPage;
    const pageNumbers: (number | string)[] = [];
    pageNumbers.push(0);
    if (currentPage > 2) {
      pageNumbers.push('...');
    }
    for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages - 2, currentPage + 1); i++) {
      pageNumbers.push(i);
    }
    if (currentPage < totalPages - 3) {
      pageNumbers.push('...');
    }
    if (totalPages > 1) {
      pageNumbers.push(totalPages - 1);
    }
    return pageNumbers;
  }

  private checkAndConvertArray(value: any) {
    return (value !== undefined && value !== null && value.length > 0) ? value : null;
  }

  resetFilters() {
    window.history.replaceState({}, '');
    const inputElement = document.querySelector('input[placeholder="Search Keyword"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.jobFilterForm.reset();
    this.getAllJobPostByFilter();
  }

  getRangeLabel(page: number, pageSize: number, length: number) {
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex}`;
  }

  onReadMore(jobPostId: any) {
    this.navigateToOtherRoute(jobPostId);
  }

  onApplyJob(jobPostId: any) {

         if(!this.userId) {
          this.authService.setLastVisitedUrl(this.router.url);
          Swal.fire({
                  iconHtml: '<img src="./assets/images/signin-icon.svg" height="90px" width="90px">',
                  iconColor: '#ffffff',
                  title: '<strong>Log in to apply for this job</strong>',
                  showCancelButton: true,
                  confirmButtonText: 'Login',
                  cancelButtonText: 'Cancel',
                  html: `<p style="font-size: 13px; margin: 0px;"> Don't have an account? <a href="/user/signup" style="color: blue;font-size: 16px;font-weight: 600; text-decoration: underline;text-wrap:nowrap">Join Now</a></p>`,
                  focusConfirm: false
                }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/login']);
            }
          });

           return;
         }
          else if(this.roleName){
           if(!this.userId) {
             this.router.navigate(['/login']);
             return;
           }
           this.navigateToOtherRoute(jobPostId, false);
       }
         else{
           this.swalService.showError('','You cannot apply for jobs');
       }
       }

  private navigateToOtherRoute(jobPostId: any, isReadMore = true) {
    const route = isReadMore ? '/jobs/job-details' : '../job-apply';
    this.router.navigate([route, jobPostId], { relativeTo: this.route, state: { viewAllJobs: true ,currentPage: this.currentPage, previousFilterForm: this.jobFilterForm?.value, isJobSaved : this.savedJobs.has(jobPostId)} });
  }

  add(event: any, val: string): void {
    this.searchSuggestions = [];
    let input: HTMLInputElement | null = null;
    let value: string = '';

    if (!val) {
      if (event?.input) {
        input = event.input;
      }
      if (event?.value) {
        value = event.value.trim();
      }
    } else {
      value = val.trim();
    }
    if (value) {
      const keywordsCurrentValue = this.jobFilterForm.get('keywords')?.value || [];
      if (!keywordsCurrentValue.includes(value)) {
        const keywordsNewValue = [...keywordsCurrentValue, value];
        this.jobFilterForm.get('keywords')?.setValue(keywordsNewValue);
      }
    }
    if (input) {
      input.value = '';
    } else {
      this.searchSuggestions = [];
    }
  }

  searchSuggestionDebouncer(event: any) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() =>
      this.searchSuggestion(event), 450);
  }

  searchSuggestion(event: any): void {
    const query =this.paramsSearch || event?.target?.value?.trim() || '';
    if (query) {
      this.careerService.searchSuggestions(query).subscribe(
        (response: any) => {
          this.searchSuggestions = response.data || [];
          this.isSugestionOpen=this.searchSuggestions.length>0;
        },
        (error) => {
          this.searchSuggestions = [];
          this.isSugestionOpen=false;
        }
      );
    } else {
      this.searchSuggestions = [];
      this.isSugestionOpen=false;
    }
  }

  selectedSuggestion(suggestion: any): void {
    if (suggestion?.name) {
      this.add(null, suggestion.name);
      const inputElement = document.querySelector('input[placeholder="Search Keyword"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = '';
      }
      this.searchSuggestions = [];
    }
  }

  remove(keyword: string): void {
    this.showNoRecordsFounds=false;
    const keywordsValue = this.jobFilterForm.get('keywords')?.value;
    const index = keywordsValue.indexOf(keyword);
    if (index >= 0) {
      keywordsValue.splice(index, 1);
      this.getAllJobPostByFilter();
    }
  }

  getPostedDate(applicationStartDate: any) {
    const startDate: any = new Date(applicationStartDate);
    const todayDate: any = new Date();
    const diffTime = Math.abs(todayDate - startDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  onSaveJob(jobPost: any) {
    if(!this.userId) {
      this.router.navigate(['/login']);
      return;
    }
    const body = { jobApplicantKey: { jobPostId: jobPost.id, applicantId: this.applicantId } };
    if (this.savedJobs.has(jobPost.id)) {
      this.unSaveJob({ jobPostId: jobPost.id, applicantId: this.applicantId });
    } else {
      this.careerService.executePostRequest(MweConstants.getJobPostUrl.concat("/applicant/jobs"), body).subscribe({
        next: () => {
          this.savedJobs.add(jobPost.id);
          Swal.fire('', 'Job saved successfully.', 'success');
        },
        error: (error) => {
          Swal.fire('', 'You are not Authorized to perform this action.', 'error');
        }

      });
    }
  }

  unSaveJob(jobData: any): void {
    this.careerService.executeDeleteRequestURL(MweConstants.deleteJobPostUrl.concat(`applicant/${jobData.applicantId}/jobs/${jobData.jobPostId}`), null, null).subscribe({
      next: () => {
        this.savedJobs.delete(jobData.jobPostId);
        this.data = this.data.filter(job => job.jobPostId !== jobData.jobPostId);

        if (this.data.length === 0) {
          this.dataSource.data = [];
        } else {
          this.dataSource = new MatTableDataSource<any[]>(this.data);
          this.dataSource.paginator = this.paginator;

          this.totalData = this.data?.length;

          const currentPageIndex = this.paginator.pageIndex;
          const pageSize = this.paginator.pageSize;
          const totalPages = Math.ceil(this.totalData / pageSize);

          if (currentPageIndex >= totalPages) {
            this.paginator.pageIndex = totalPages - 1;
          }
        this.paginator._changePageSize(pageSize);
        }

        Swal.fire('', 'Job unsaved successfully.', 'success');
      },
      error: (error) => {
        Swal.fire('', 'You are not Authorized to perform this action.', 'error');
      }
    });
  }

  isJobSaved(jobPost: any): boolean {
    return this.savedJobs.has(jobPost.id);
  }

  private getJobPostById() {
    this.careerService.executeGetRequestURL(MweConstants.getJobPostUrl.concat('/', this.careerService.getJobId()), null).subscribe({
      next: (response: any) => {
        if (response && response?.data) {
          const jobPostResponse = response?.data;
          this.salaryHide = jobPostResponse.hideSalary;
   }
      }, error: (error: any) => {
      }
    });
  }
  onSortChange(sortOption: string, direction: string) {
    if (!sortOption) return;
    const normalizeString = (str: string) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    switch (sortOption) {
      case 'alphabetical':
        this.data.sort((a, b) =>
          direction === 'asc'
            ? normalizeString(a.title).localeCompare(normalizeString(b.title))
            : normalizeString(b.title).localeCompare(normalizeString(a.title))
        );
        break;
      case 'date':
        this.data.sort((a, b) =>
          direction === 'asc'
            ? new Date(a.applicationStartDate).getTime() - new Date(b.applicationStartDate).getTime()
            : new Date(b.applicationStartDate).getTime() - new Date(a.applicationStartDate).getTime()
        );
        break;
      case 'createdOn':
        this.data.sort((a, b) =>
          direction === 'asc'
            ? new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
            : new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
        );
        break;
      default:
        break;
    }
    this.dataSource = new MatTableDataSource<any[]>(this.data);
    this.dataSource.paginator = this.paginator;
    this.obs = this.dataSource.connect();
  }
  onSortOptionSelected(sortOption: string) {
    this.selectedSortOption = sortOption;
    this.currentSortDirection = 'asc';
    this.onSortChange(sortOption, 'asc');
  }

  toggleSortDirection() {
    this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    if (this.selectedSortOption) {
      this.onSortChange(this.selectedSortOption, this.currentSortDirection);
    }

  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: this.currentPage },
      queryParamsHandling: 'merge',
    });
  }
}
